/**
 * src/components/ConfirmModal.tsx
 *
 * Reusable confirmation dialog.
 * Usage:
 *   const [modal, setModal] = useState<ConfirmModalProps | null>(null);
 *   ...
 *   setModal({ title:"Supprimer ?", message:"...", onConfirm:()=>doIt(), danger:true });
 *   ...
 *   {modal && <ConfirmModal {...modal} onCancel={()=>setModal(null)}/>}
 */

export interface ConfirmModalProps {
  title:       string;
  message:     string;
  confirmLabel?: string;
  cancelLabel?:  string;
  danger?:     boolean;
  /** Si true : modale plus large (520px) — pour les libellés de boutons longs qui ne tiennent pas sur une ligne à 420px. */
  wide?:       boolean;
  onConfirm:   () => void;
  onCancel:    () => void;
}

export default function ConfirmModal({
  title, message, confirmLabel = "Confirmer", cancelLabel = "Annuler",
  danger = false, wide = false, onConfirm, onCancel,
}: ConfirmModalProps) {
  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal" style={{ maxWidth: wide ? 520 : 420 }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: "24px 28px" }}>
          <h2 className="t-title" style={{
            fontSize: 18,
            color: danger ? "var(--red)" : "var(--text-primary)",
            marginBottom: 10,
          }}>
            {title}
          </h2>
          <p style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.6, marginBottom: 24, whiteSpace: "pre-line" }}>
            {message}
          </p>
          <div className="flex gap-10" style={{ justifyContent: "flex-end" }}>
            <button onClick={onCancel} className="btn btn-ghost">
              {cancelLabel}
            </button>
            <button
              onClick={() => { onConfirm(); onCancel(); }}
              className={`btn ${danger ? "btn-danger" : "btn-black"}`}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
